import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Box, Skeleton } from '@mui/material'
import { FaCircleCheck } from "react-icons/fa6";
import { useEffect } from 'react';
import { useState } from 'react';


import { SetToPlay } from "../../../redux/v2/favorite/actions";
import { SetSelectedProgram } from "../../../redux/v2/program/actions";
import { SetSelectedWorkout, GetPendingWorkout } from "../../../redux/v2/workout/actions";
import { UpdateFavorite } from '../../../redux/v2/user/actions';
import { delay } from '../../../utils';

import { programLevels } from '../../../constants';
import ProgressBar from '../../../common/ProgressBar';

import moment from 'moment';
import { Heart } from '../../../common/CustomIcons';
import { GrUndo } from 'react-icons/gr';


const WorkoutCard = (props) => {
    const navigate = useNavigate();
    const [skeleton, setSkeleton] = useState(true)
    const [cover, setCover] = useState(false)
    const [timer, setTimer] = useState(null);

    const { video, isFavorite, isViewdWorkout, program, disableLink = false } = props;

    useEffect(() => {
        setTimeout(() => setSkeleton(false), 500)
    }, [])

    const gradient = program?.gradient ? program?.gradient?.split("-") : null;
    return (
        <Box className='t-card' display='flex' sx={{ cursor: disableLink ? "default" : "pointer", p: 1, border: isViewdWorkout ? ("3px solid " + gradient?.[0]) : "" }} onClick={async (e) => {
            if (!disableLink) {
                if (e.target.nodeName != "path" && e.target.nodeName != "svg") {
                    if (video?.id) {
                        props.SetSelectedWorkout(video);
                        props.SetSelectedProgram(program);

                        navigate(`/workout?workout=${video?.id}`);
                    }
                }
            }
        }}>
            <Box className='main-wrapper' style={{ marginRight: "5px" }}>
                <div className='img-wrapper'>
                    {(skeleton) ? (
                        <Skeleton className='skeleton-img' variant="rectange" />
                    ) : (
                        <>
                            <div className='img-holder'>
                                <div className='img-holder-desc'>
                                </div>
                                <img src={video?.image + "_295x166"} />
                            </div>

                        </>
                    )}

                </div>

            </Box>
            <Box className='card-description'>
                <div className='card-description-wrapper'>
                    <h5>{program?.title || ""}</h5>
                    <body>Workout {video?.workout_number ? (video?.workout_number + "").padStart(2, "0") : ""}</body>
                </div>
            </Box>

        </Box >
    );
};

const mapStateToProps = (state) => ({
    Program: state.Program
});

export default connect(mapStateToProps, {
    SetToPlay,
    SetSelectedProgram,
    SetSelectedWorkout,
    GetPendingWorkout,
    UpdateFavorite,
})(WorkoutCard);